import { useId } from 'react'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type TimeFieldProps = {
  label: string
  /** Local wall-clock time, HH:mm. */
  value: string
  onChange: (value: string) => void
  error?: string
}

export function TimeField({ label, value, onChange, error }: TimeFieldProps) {
  const fieldId = useId()
  return (
    <FieldShell id={fieldId} label={label} error={error}>
      <input
        id={fieldId}
        className="ui-input"
        type="time"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(error && `${fieldId}-error`)}
      />
    </FieldShell>
  )
}
